import { StrictMode } from "react";
import type { ReactElement } from "react";
import { createRoot } from "react-dom/client";
import { DebugPage } from "./pages/debug";
import { DisplayPage } from "./pages/display";
import { IndexPage } from "./pages/index";
import "./styles.css";

const routes: Record<string, ReactElement> = {
  "/": <IndexPage />,
  "/display": <DisplayPage />,
  "/display.html": <DisplayPage />,
  "/debug": <DebugPage />
};

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Missing root element");

const normalizedPath = window.location.pathname.replace(/\/+$/, "") || "/";

createRoot(rootElement).render(<StrictMode>{routes[normalizedPath] || <IndexPage />}</StrictMode>);
